var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('img',{staticClass:"level-indicator",attrs:{"src":_vm.generateIcon(_vm.status)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }